import { baseFetchToken, baseFetchTokenFullResponse } from './BaseSaga'
import FailedTransactionActions from '../Redux/FailedTransactionRedux'
import { getToken } from '../Services/GetToken'

export function * getFailedTransaction (api, action) {
  yield baseFetchTokenFullResponse(
    api.getFailedTransaction,
    action.data,
    getToken,
    FailedTransactionActions.getFailedTransactionSuccess,
    FailedTransactionActions.getFailedTransactionFailure
  )
}

export function * triggerFailedTransaction (api, action) {
  yield baseFetchToken(
    api.triggerFailedTransaction,
    action.data,
    getToken,
    FailedTransactionActions.triggerFailedTransactionSuccess,
    FailedTransactionActions.triggerFailedTransactionFailure
  )
}



// WEBPACK FOOTER //
// ./src/Sagas/FailedTransactionSagas.js